<template>
  <div class="main-wrapper border-t-2 border-gray-400">
    <div class="flex w-full py-2 mt-2">
      <div class="w-6/12">
        <h6 :style="`color: #9BA0A7; font-size: 12px; font-weight: 500;`">Name</h6>
      </div>
      <div class="w-6/12">
        <h6 :style="`color: #9BA0A7; font-size: 12px; font-weight: 400;`">Amount</h6>
      </div>
    </div>
    <div class="flex w-full list-contain " v-for="(value, key) in dataList" :key="key">
      <div class="w-6/12">
        <span class="w-full block" :style="keyStyles[key]">
          
          {{ labelMap[key] || key }}
          </span>
      </div>
      <div class="w-6/12">
        <span class="w-full flex items-center">
          <abbr class="list-amount">
            
            ₦ {{ formatValue(value) }}
          </abbr>
        </span>
      </div>
    </div>
   
  </div>
</template>

<script>
export default {
  
  props: {
    dataList: { type: Object },
  },
  data() {
    return {
      keyStyles: {
        inApp: "color: #D72638; font-weight: 400; font-size: 14px;",
        refunded: "color: #D72638; font-weight: 400; font-size: 14px;",
        cashOnDelivery: "color: #09B78A; font-weight: 400; font-size: 14px;",
        paid: "color: #09B78A; font-weight: 400; font-size: 14px;",
        pending: "color: #FFA600; font-weight: 400; font-size: 14px;",
        total: "color: #10233E; font-weight: 600; font-size: 14px;",
      },
      labelMap: {
        inApp: "In-App",
        cashOnDelivery: "Cash-on-Delivery",
        total: "Total (NGN)",
        pending: "Pending Payments",
        paid: "Paid",
        refunded: "Refunded",
      },
    };
  },

   methods: {
      formatValue(val) {
        const formatter = new Intl.NumberFormat("en-NG", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return formatter.format(Number(val));
      },
    },
  
};
</script>

<style lang="scss" scoped>
.list-amount {
  display: block;
  white-space: nowrap;
  width: calc(100% - 80px);
  color: #10233E;
  font-size: 14px;
  font-weight: 400;
}

.list-contain:nth-child(even) {
  @apply bg-gray-200;
}

.main-wrapper {
  @apply w-full flex px-3 flex-wrap;
}
</style>
